export interface OrderSettings {
  confirmStatus: 'confirmed' | false;
  paymentType: boolean | 'dineIn' | 'pickUp';
  submitType:
    | {
        action: 'submitOrder' | 'payOrder';
        paymentType: 'dineIn' | 'pickUp';
      }
    | false;
  confirmedData: any;
  customerOrderInfo:
    | {
        customerName: string;
        customerPhone: string | number;
        customerEmail?: string;
      }
    | false;
}
export default {
  confirmStatus: false,
  paymentType: 'dineIn',
  submitType: false,
  customerOrderInfo: false,
} as OrderSettings;

export const spaceName = 'caOrderProcess';
